import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index'
import mobile from '../views/mobile.vue'
import weixinlogin from '../views/weixinlogin.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    meta: { title: "西安高慧智能科技有限公司" },
    component: index
  },
  {
    path: '/mobile',
    name: 'mobile',
    meta: { title: "西安高慧智能科技有限公司" },
    component: mobile
  },
  {
    path: '/weixinlogin',
    name: 'weixinlogin',
    meta: { title: "西安高慧智能科技有限公司" },
    component: weixinlogin
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
